import * as React from "react";
import { forwardRef } from "react";
const SvgMoveFolder = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 4h4l2 2.5h8q1 0 1 1V15q0 1-1 1H3q-1 0-1-1V5q0-1 1-1m2.5 6.75h5V9l4 3-4 3v-1.75h-5Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgMoveFolder);
export default ForwardRef;
